const DOCUMENT = 'PREDICTIONS_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_FUNNEL_DATA: DOCUMENT + 'LOAD_FUNNEL_DATA',
  LOAD_FUNNEL_DATA_SUCCESS: DOCUMENT + 'LOAD_FUNNEL_DATA_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadFunnelData: data => ({
    type: actions.LOAD_FUNNEL_DATA,
    payload: data,
  }),

  loadFunnelDataSuccess: data => ({
    type: actions.LOAD_FUNNEL_DATA_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
